// extracted by mini-css-extract-plugin
module.exports = {"botton":"HomeCard_botton__2pnSX","title":"HomeCard_title__3kFRZ","subTitle":"HomeCard_subTitle__3NvTe","amount":"HomeCard_amount__19bPY","eachCase":"HomeCard_eachCase__3LGYY"};